import React, { Component } from 'react';
import {
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    Tabs,
    Tab,
    Box
} from '@material-ui/core';
import { Settings } from '@material-ui/icons';
import EmployeesDialog from '../components/EmployeesDialog';
import HolidaysDialog from '../components/HolidaysDialog';
import EmployeeControlTable from '../components/EmployeeControlTable';
import './ControlTimeManagementPage.css';

class ControlTimeManagementPage extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            dialogOpen: false,
            activeTab: 0
        };
    }

    handleOpenDialog = () => {
        this.setState({ dialogOpen: true });
    }

    handleCloseDialog = () => {
        this.setState({ dialogOpen: false, activeTab: 0 });
        this.tableRef.current.loadData();
    }

    handleTabChange = (event, newValue) => {
        this.setState({ activeTab: newValue });
    }

    render() {
        const { dialogOpen, activeTab } = this.state;

        return (
            <div className="control-time-management-page">
                <div className="management-header">
                    <h1>Control de Tiempo - Gestión</h1>
                    <Tooltip title="Ajustes">
                        <IconButton
                            color="primary"
                            onClick={this.handleOpenDialog}
                            className="settings-button"
                        >
                            <Settings fontSize="large" />
                        </IconButton>
                    </Tooltip>
                </div>

                <EmployeeControlTable ref={this.tableRef} />

                <Dialog
                    open={dialogOpen}
                    onClose={this.handleCloseDialog}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>
                        Ajustes
                    </DialogTitle>
                    <DialogContent>
                        <Tabs
                            value={activeTab}
                            onChange={this.handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                        >
                            <Tab label="Empleados" />
                            <Tab label="Festivos" />
                        </Tabs>

                        <Box mt={2}>
                            {activeTab === 0 && (
                                <EmployeesDialog
                                    open={true}
                                    onClose={() => { }}
                                />
                            )}
                            {activeTab === 1 && (
                                <HolidaysDialog
                                    open={true}
                                    onClose={() => { }}
                                />
                            )}
                        </Box>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

export default ControlTimeManagementPage;
